import { render, staticRenderFns } from "./DataDeletionTable.vue?vue&type=template&id=3b9483e4&scoped=true&"
import script from "./DataDeletionTable.vue?vue&type=script&lang=js&"
export * from "./DataDeletionTable.vue?vue&type=script&lang=js&"
import style0 from "./DataDeletionTable.vue?vue&type=style&index=0&id=3b9483e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9483e4",
  null
  
)

export default component.exports